import { css } from '@linaria/core';
import { LiveLabel as TeaserLiveLabel } from '../Labels/styles';
export const Root = {
    base: css `
		&&&& {
			background: rgb(var(--label-color-background-primary));
		}
	`,
    isLive: TeaserLiveLabel.base,
};
